import React, { useEffect, useState } from 'react';
import {Modal, Input, Table, Pagination, Space} from 'antd';
import {ColumnsType} from "antd/es/table";
import {searchSounds} from "../../helpers/api/sound";

const { Search } = Input;


interface SoundModel {
    key: React.Key;
    id: string;
    name: string;
    soundUrl: string;
}


const SoundSelectionModal = (
    {
        open,
        onClose,
        onConfirm = (backgroundId :  any) => {},
        sounds = [] as SoundModel[]

    } :  any
) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([sounds]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filters, setFilters] = useState({
        search: '',
    });


    // Columns cho Table
    const columns :  ColumnsType<SoundModel> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                return (
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <span>{text}</span>
                    </div>
                );
            }
        },
        {
            title: 'Audio',
            dataIndex: 'soundUrl',
            key: 'soundUrl',
            render: (text, record, index) => {
                return (
                    <audio controls style={{width: "100%"}}>
                        <source src={record.soundUrl} type="audio/mpeg"/>
                        Your browser does not support the audio element.
                    </audio>
                );
            }
        }
    ];

    // Fetch data
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await searchSounds({
                name: filters.search,
                pageIndex: currentPage - 1,
                pageSize,
            });
            setData(response.data.data);
            setTotal(response.data.totalRecord);
        } catch (err) {
            console.error('Failed to fetch data', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchData();
        }
    }, [open, filters, currentPage, pageSize]);

    return (
        <Modal
           open={open}
            title="Select sound"
            onCancel={onClose}
            footer={null}
            width={700}
        >
            <Space style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <Search
                    placeholder="Search name"
                    onSearch={(value) => setFilters({ ...filters, search: value })}
                    style={{ width: 400 }}
                />
            </Space>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => {
                        onConfirm(record.id);
                        onClose();
                    },
                })}
                rowClassName={() => 'clickable-row'}
                style={{ cursor: 'pointer', maxHeight: 400, overflowY: 'auto' }}
            />

            <Pagination
                style={{ marginTop: 16, textAlign: 'right' }}
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={(page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                }}
                showSizeChanger
            />
        </Modal>
    );
};

export default SoundSelectionModal;
